import axios from 'axios';

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatError(e) {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || 'Une erreur est survenue';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(d => d?.msg || JSON.stringify(d)).join(' ');
  return String(detail);
}

export default API;
